import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { FormTypeId } from '~/common/constants/formTypes'

export type FormState = {
  // クライアントID
  clientId?: string
  // フォームタイプ
  formType?: FormTypeId
  // フォーム名
  formName?: string
  // 画面ID
  page?: 'input' | 'confirm' | 'thanks'
  employmentStatus?: string
}

const initialState: FormState = {}

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setClientId: (state, action: PayloadAction<FormState['clientId']>) => {
      state.clientId = action.payload
    },
    setFormType: (state, action: PayloadAction<FormState['formType']>) => {
      state.formType = action.payload
    },
    setPage: (state, action: PayloadAction<FormState['page']>) => {
      state.page = action.payload
    },
    setFormName: (state, action: PayloadAction<FormState['formName']>) => {
      state.formName = action.payload
    },
    setEmploymentStatus: (
      state,
      action: PayloadAction<FormState['employmentStatus']>
    ) => {
      state.employmentStatus = action.payload
    },
  },
})

/** Action */
export const {
  setClientId,
  setFormType,
  setPage,
  setFormName,
  setEmploymentStatus,
} = formSlice.actions

/** Reducer */
export default formSlice.reducer
